module.exports = __webpack_public_path__ + "static/media/automated.b8a39a92.svg";